export default function ({ store }) {
  if (store.state.menuIsActive === !false) {
    store.commit('setMenuState', false)
  }
}
